import React from "react";
import { Plug } from "lucide-react";
import MetaBridgePage from "./MetaBridgePage";

export default function ServiceFhir() {
  return (
    <MetaBridgePage
      title="API FHIR R4 : interopérabilité HL7 pour éditeurs · MetaConnect"
      metaDescription="HL7 FHIR R4 en pratique : couche d'API, profils CI-SIS, mapping HL7 v2 et CDA, SMART on FHIR. Pour les éditeurs de logiciels et les établissements de santé."
      canonical="/services/fhir"
      eyebrow="HL7 FHIR R4"
      h1="L'interopérabilité santé au standard FHIR R4."
      intro="MetaBridge FHIR fournit une couche d'interopérabilité prête à l'emploi pour échanger des données de santé structurées entre vos systèmes, vos partenaires et les services socles nationaux — au standard HL7 FHIR R4."
      icon={<Plug size={26} />}
      testIdSlug="fhir"
      bullets={[
        "Serveur FHIR R4 conforme aux profils CI-SIS",
        "Mapping bidirectionnel HL7 v2.x ⇄ FHIR ⇄ CDA",
        "Ressources Patient, Encounter, Observation, Practitioner, Organization…",
        "OAuth 2.0 SMART on FHIR pour l'autorisation",
        "Webhooks et subscription pour les workflows événementiels",
        "Conforme à la doctrine technique ANS et au Ségur",
      ]}
      details={[
        { title: "Standards", desc: "HL7 FHIR R4 (4.0.1), profils CI-SIS, IHE MHD, SMART on FHIR." },
        { title: "Sécurité", desc: "OAuth 2.0, TLS 1.3, journalisation conforme PGSSI-S, hébergement HDS." },
        { title: "Ressources", desc: "60+ ressources FHIR · Patient, Practitioner, Organization, Encounter, Observation, Condition, etc." },
      ]}
      useCases={[
        { tag: "Éditeur", title: "Couche d'API", desc: "Exposer les données du logiciel métier au standard FHIR pour les partenaires et plateformes nationales." },
        { tag: "Hôpital", title: "ESB santé", desc: "Bus d'interopérabilité interne pour intégrer SIH, biologie, imagerie, pharmacie." },
        { tag: "Recherche", title: "Entrepôt de données", desc: "Alimentation d'un Health Data Warehouse FHIR pour la recherche clinique." },
        { tag: "Mobile", title: "Application patient", desc: "App mobile patient consommant les données de santé via SMART on FHIR." },
      ]}
      faq={[
        { q: "FHIR remplace-t-il HL7 v2 et CDA ?", a: "Non. FHIR est le standard d'échange recommandé pour les nouveaux développements, mais HL7 v2 et CDA restent largement déployés. MetaBridge FHIR fait le pont entre les trois." },
        { q: "Faut-il être conforme Ségur ?", a: "Le Ségur du Numérique en Santé impose progressivement FHIR pour les échanges nationaux (DMP, MSSanté, INS). MetaBridge FHIR vous met sur la trajectoire." },
        { q: "Quelle différence avec un simple serveur FHIR ?", a: "MetaBridge intègre les profils CI-SIS de l'ANS, le mapping HL7v2/CDA, l'authentification Pro Santé Connect et l'hébergement HDS — clé en main." },
      ]}
    />
  );
}
